import { LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { SELECTORS } from '../../constants/selectors';

/**
 * ログインフォーム切替コンポーネント
 *
 * @element kd-login-form-switcher
 * @description ログイン / パスワード回復フォーム切替とパンくず更新を制御する。
 *              URL ハッシュ (#recover / #login) に基づいてパンくずテキストを更新する。
 */
@customElement('kd-login-form-switcher')
export class KdLoginFormSwitcher extends LitElement {
  createRenderRoot() {
    return this;
  }

  private boundHandleHashChange: (() => void) | null = null;

  connectedCallback(): void {
    super.connectedCallback();

    this.boundHandleHashChange = this.updateBreadcrumb.bind(this);
    window.addEventListener('hashchange', this.boundHandleHashChange);

    // 初期状態をチェック
    this.updateBreadcrumb();
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();

    if (this.boundHandleHashChange) {
      window.removeEventListener('hashchange', this.boundHandleHashChange);
      this.boundHandleHashChange = null;
    }
  }

  private updateBreadcrumb(): void {
    const hash = window.location.hash;
    const isRecover = hash === '#recover';
    const text = isRecover ? 'パスワードをリセットする' : 'ログイン';

    const topEl = document.querySelector(SELECTORS.ACCOUNT.BREADCRUMB_LOGIN_TOP);
    const bottomEl = document.querySelector(SELECTORS.ACCOUNT.BREADCRUMB_LOGIN_BOTTOM);

    if (topEl) topEl.textContent = text;
    if (bottomEl) bottomEl.textContent = text;
  }

  render() {
    return nothing;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'kd-login-form-switcher': KdLoginFormSwitcher;
  }
}
